export const sanitizeString = (str?: string) => str?.replace(/[^A-Z0-9]+/ig, "_") || "";
